import { OpenGraphItems } from 'shared/components/Head/types';

export const getOpenGraphValues = (
    url: string,
    title: string,
    type: string,
    image: string,
    description: string
): OpenGraphItems => {
    return [
        { property: 'og:url', content: url },
        { property: 'og:title', content: title },
        { property: 'og:type', content: type },
        { property: 'og:image', content: image },
        { property: 'og:description', content: description }
    ];
};
